// Project: GSSC Pilot Front-end
// Filename: resource_types.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.

// defines the order of the columns in the resource_types table
export function getSelectableColumns() {
  return [
    'ID',
    'Name',
    'Characteristics',
    'Format',
    'Quality Checks',
    'Resource Type Labs',
    'Scientific Domains',
    'Picture'
  ];
}

// defines which of the fields return arrays
export function getArrayFields() {
  return ['Resource Type Labs', 'Format', 'Scientific Domains'];
}

// defines the mapping between column name and API field
export function getDataMapping() {
  return {
    ID: 'resource_type_id',
    Name: 'name',
    Characteristics: 'characteristics',
    Format: 'format',
    'Quality Checks': 'quality_checks',
    'Resource Type Labs': 'resource_type_labs',
    'Scientific Domains': 'scientific_domains',
    Picture: 'picture'
  };
}
// defines the mapping between column name and API field
export function sortableColumns() {
  return {
    ID: 'resource_type_id',
    Name: 'name',
    Characteristics: 'characteristics',
    Format: 'format',
    'Quality Checks': 'quality_checks',
    'Resource Type Labs': 'resource_type_labs',
    'Scientific Domains': 'scientific_domains'
  };
}
